import defaultAttributes from '../defaultAttributes';

const UserCheck = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2' }],
    ['circle', { cx: '8.5', cy: '7', r: '4' }],
    ['polyline', { points: '17 11 19 13 23 9' }],
  ],
];

export default UserCheck;
